import React from 'react';
import FormBase from '../../components/forms/FormBase';
import IdentificacaoCaracterizacao from '../../components/forms/diagnostico-municipal/01_IdentificacaoCaracterizacao';
import MeioAmbienteRecursosHidricos from '../../components/forms/diagnostico-municipal/02_MeioAmbienteRecursosHidricos';
import SaneamentoResiduos from '../../components/forms/diagnostico-municipal/03_SaneamentoResiduos';
import EducacaoSaude from '../../components/forms/diagnostico-municipal/04_EducacaoSaude';
import TransporteMobilidade from '../../components/forms/diagnostico-municipal/05_TransporteMobilidade';
import AtividadesEconomicas from '../../components/forms/diagnostico-municipal/06_AtividadesEconomicas';
import HabitacaoSeguranca from '../../components/forms/diagnostico-municipal/07_HabitacaoSeguranca';
import CulturaEsporteLazer from '../../components/forms/diagnostico-municipal/08_CulturaEsporteLazer';
import GovernancaPlanejamento from '../../components/forms/diagnostico-municipal/09_GovernancaPlanejamento';
import DesenolvimentoRegionalDiagnostico from '../../components/forms/diagnostico-municipal/10_DesenolvimentoRegionalDiagnostico';
import { FormAccessGuard } from '../../hooks/useFormEnabled';
import { FORMS_BY_ID } from '../../config/forms';

const DiagnosticoMunicipal = () => {
  const sections = [
    {
      title: '1. Identificação e Caracterização Geral do Município',
      fields: [
        'nome_municipio',
        'codigo_ibge',
        'secretaria_referencia',
        'populacao_urbana',
        'populacao_rural',
        'area_territorial',
        'densidade_demografica',
        'problemas_caracterizacao',
        'demandas_caracterizacao',
        'fontes_principais_secao1',
        'links_acesso_secao1',
      ],
    },
    {
      title: '2. Meio Ambiente e Recursos Hídricos',
      fields: [
        'meio_ambiente_recursos_hidricos_situacao',
        'meio_ambiente_recursos_hidricos_indicadores',
        'meio_ambiente_recursos_hidricos_problemas',
        'meio_ambiente_recursos_hidricos_demandas',
        'fontes_principais_secao2',
        'links_acesso_secao2',
      ],
    },
    {
      title: '3. Saneamento e Resíduos Sólidos',
      fields: [
        'saneamento_residuos_situacao',
        'saneamento_residuos_indicadores',
        'saneamento_residuos_problemas',
        'saneamento_residuos_demandas',
        'fontes_principais_secao3',
        'links_acesso_secao3',
      ],
    },
    {
      title: '4. Educação, Ensino Superior, Qualificação e Saúde',
      fields: [
        'educacao_saude_situacao',
        'educacao_saude_indicadores',
        'educacao_saude_problemas',
        'educacao_saude_demandas',
        'fontes_principais_secao4',
        'links_acesso_secao4',
      ],
    },
    {
      title: '5. Transporte, Mobilidade e Infraestrutura Viária',
      fields: [
        'transporte_mobilidade_viaria_situacao',
        'transporte_mobilidade_viaria_indicadores',
        'transporte_mobilidade_viaria_problemas',
        'transporte_mobilidade_viaria_demandas',
        'fontes_principais_secao5',
        'links_acesso_secao5',
      ],
    },
    {
      title: '6. Agricultura, Indústria, Comércio, Serviços e Turismo',
      fields: [
        'atividades_economicas_situacao',
        'atividades_economicas_indicadores',
        'atividades_economicas_problemas',
        'atividades_economicas_demandas',
        'fontes_principais_secao6',
        'links_acesso_secao6',
      ],
    },
    {
      title: '7. Habitação e Segurança Pública',
      fields: [
        'habitacao_seguranca_situacao',
        'habitacao_seguranca_indicadores',
        'habitacao_seguranca_problemas',
        'habitacao_seguranca_demandas',
        'fontes_principais_secao7',
        'links_acesso_secao7',
      ],
    },
    {
      title: '8. Cultura, Esporte e Lazer',
      fields: [
        'cultura_esporte_lazer_situacao',
        'cultura_esporte_lazer_indicadores',
        'cultura_esporte_lazer_problemas',
        'cultura_esporte_lazer_demandas',
        'fontes_principais_secao8',
        'links_acesso_secao8',
      ],
    },
    {
      title: '9. Governança e Planejamento Municipal',
      fields: [
        'governanca_planejamento_situacao',
        'governanca_planejamento_indicadores',
        'governanca_planejamento_problemas',
        'governanca_planejamento_demandas',
        'fontes_principais_secao9',
        'links_acesso_secao9',
      ],
    },
    {
      title: '10. Desenvolvimento Regional e Diagnóstico Final',
      fields: [
        'potencialidades_projetos_integracao',
        'pib_per_capita',
        'empregos_formais',
        'idhm',
        'receita_propria',
        'desenvolvimento_regional_problemas',
        'desenvolvimento_regional_demandas',
        'diagnostico_sintese',
        'fontes_principais_secao10',
        'links_acesso_secao10',
      ],
    },
  ];

  return (
    <FormBase
      formType="diagnostico-municipal"
      formTitle="Formulário - Diagnóstico Municipal da RIDE-DF"
      formDescription="Preencha os dados do diagnóstico municipal da região da RIDE-DF. Os dados coletados serão utilizados para análises e estudos do Observatório Socioeconômico e Ambiental."
      sections={sections}
    >
      {/* Seção 1: Identificação e Caracterização Geral do Município */}
      <IdentificacaoCaracterizacao />

      {/* Seção 2: Meio Ambiente e Recursos Hídricos */}
      <MeioAmbienteRecursosHidricos />

      {/* Seção 3: Saneamento e Resíduos Sólidos */}
      <SaneamentoResiduos />

      {/* Seção 4: Educação, Ensino Superior, Qualificação e Saúde */}
      <EducacaoSaude />

      {/* Seção 5: Transporte, Mobilidade e Infraestrutura Viária */}
      <TransporteMobilidade />

      {/* Seção 6: Agricultura, Indústria, Comércio, Serviços e Turismo */}
      <AtividadesEconomicas />

      {/* Seção 7: Habitação e Segurança Pública */}
      <HabitacaoSeguranca />

      {/* Seção 8: Cultura, Esporte e Lazer */}
      <CulturaEsporteLazer />

      {/* Seção 9: Governança e Planejamento Municipal */}
      <GovernancaPlanejamento />

      {/* Seção 10: Desenvolvimento Regional e Diagnóstico Final */}
      <DesenolvimentoRegionalDiagnostico />
    </FormBase>
  );
};

const DiagnosticoMunicipalGuarded = () => (
  <FormAccessGuard formId="diagnostico-municipal" formTitle={FORMS_BY_ID['diagnostico-municipal'].title}>
    <DiagnosticoMunicipal />
  </FormAccessGuard>
);

export default DiagnosticoMunicipalGuarded;
